import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useMemo } from 'react';
import { flatten } from 'lodash';
import { cnBem } from "../../../../shared/lib";
import { EBtnTypeAnalytics, useViewFaqItemsAnalytics, ymPushSendViewQuickButton } from "../../../../shared/analytics";
import styles from "./styles.pcss";
import { QuickButton } from "../QuickButton";
var cnQuickRequest = cnBem('quick-request', styles);
export var QuickRequest = function QuickRequest(_ref) {
  var itemsProp = _ref.items,
    onItemClick = _ref.onItemClick,
    zoneType = _ref.zoneType,
    className = _ref.className;
  var setFaqItemVisibility = useViewFaqItemsAnalytics();
  var handleClick = function handleClick(item) {
    return function () {
      return onItemClick(item);
    };
  };
  var onVisible = function onVisible(item) {
    return function (flag) {
      return setFaqItemVisibility(item.title, flag);
    };
  };
  var items = useMemo(function () {
    return flatten(itemsProp);
  }, [itemsProp]);

  /**
   * Отправки аналитики. Показ популярных запросов.
   * */
  useEffect(function () {
    if (items !== null && items !== void 0 && items.length) {
      var list = items.map(function (item) {
        return item.title;
      });
      ymPushSendViewQuickButton(list, EBtnTypeAnalytics.popular, zoneType);
    }
  }, []);
  return /*#__PURE__*/React.createElement("section", {
    className: cnQuickRequest(null, [className])
  }, items.map(function (item, i) {
    return /*#__PURE__*/React.createElement(QuickButton, _extends({}, item, {
      key: cnQuickRequest('item', {
        i: i
      }),
      onClick: handleClick(item),
      onVisible: onVisible(item)
    }));
  }));
};